module.exports = __webpack_public_path__ + "static/media/return_bus.838d4eff.svg";